import Vue from "vue";
import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"organisation",
	api.organisations
)({
	mutations: {
		loginOrgSuccess(state, { organisation }) {
			Vue.set(state.byID, organisation.id, organisation);
		},
		userLoadSuccess(state, user) {
			if (user.organisation) {
				Vue.set(state.byID, user.organisation.id, user.organisation);
			}
		}
	},
	actions: {
		async organisationsUserInvite(context, invites) {
			try {
				const response = await api.inviteUsers(invites);
				// eslint-disable-next-line
				console.log(response);
				// context.commit(`userInsertSuccess`, response.user);
				// return response.user;
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
			// console.log(invite, '<<<<< invite');
		}
	}
});
